import React from "react";
import "./NewsCard.css";
import {buildNewsImageUrl, formatNewsDate, navigateTo} from "../utils";

export default function NewsCard({article}) {
    const imageUrl = buildNewsImageUrl(article.cover_image_url);

    return (
        <a
            className="news-card"
            href={`/actualites/${article.slug}`}
            onClick={e => { e.preventDefault(); navigateTo(`/actualites/${article.slug}`); }}
        >
            <div className="news-card-media">
                {imageUrl
                    ? <img src={imageUrl} alt={article.cover_image_alt || ""}/>
                    : <span className="news-card-placeholder" aria-hidden="true">📰</span>}
            </div>
            <div className="news-card-body">
                <div className="news-card-meta">
                    {article.category && <span className="news-card-category">{article.category}</span>}
                    <span className="news-card-date">{formatNewsDate(article.published_at)}</span>
                </div>
                <h3 className="news-card-title">{article.title}</h3>
                <p className="news-card-excerpt">{article.excerpt}</p>
                <span className="news-card-cta">Lire la suite →</span>
            </div>
        </a>
    );
}
